"use client";

import React from "react";
import { ShieldCheck, Target, Activity } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const bentoItems = [{
  id: "accuracy",
  title: "Accuracy",
  subtitle: "Flawless Execution",
  description: "Our payroll and administrative systems are engineered for zero-defect processing. We ensure your workforce is compensated correctly and on time, every time, eliminating costly errors and maintaining employee trust.",
  icon: Target,
  className: "md:col-span-8"
}, {
  id: "security",
  title: "Security",
  subtitle: "Ironclad Protection",
  description: "Enterprise-grade security protocols safeguard sensitive employee data and financial transactions against unauthorized access, maintaining absolute confidentiality and regulatory compliance across all operations.",
  icon: ShieldCheck,
  className: "md:col-span-4 md:row-span-2"
}, {
  id: "reliability",
  title: "Reliability",
  subtitle: "Unwavering Consistency",
  description: "Dependable day-to-day management that scales effortlessly with your operational needs. We provide a stable, predictable foundation for your business growth and workforce management strategy.",
  icon: Activity,
  className: "md:col-span-8"
}];
export default function AdministrativeIntegrity() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}